import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client"
// Makes window.fetch available in Node.js at runtime
import fetch from "cross-fetch"

const serverUrl = process.env.NEXT_PUBLIC_API_URL || ""
const stage = process.env.NEXT_PUBLIC_ENV == "development" ? "/development" : ""

export const youTubeBaseUrl = `https://youtube.com/shorts`

export const apolloClient = new ApolloClient({
  link: new HttpLink({
    uri: `${serverUrl}${stage}/graphql`,
    fetch,
  }),
  cache: new InMemoryCache(),
})

export const never = (arg: never) => {
  throw new TypeError(JSON.stringify(arg))
}
